/**
 * Status History API Service
 *
 * Fetch layer for the carrier authority/status change-history endpoint:
 *   GET /api/carriers/:dotNumber/status-history
 *
 * Uses the shared axios API service (JWT injection, 401 redirect, error
 * handling) — never raw fetch().
 */

import api from './api';
import type {
  StatusHistoryQueryParams,
  StatusHistoryResult,
} from '../types/statusHistory';

/**
 * Get a carrier's recorded authority/status change events, newest first.
 *
 * The backend envelope is `{ success, data: events, total, count, limit,
 * offset, windowDays }`; the axios response interceptor unwraps it and
 * re-wraps as `{ data, total, hasMore, count, limit, offset }`, which is
 * what this function returns.
 */
export async function getCarrierStatusHistory(
  dotNumber: number,
  params?: StatusHistoryQueryParams
): Promise<StatusHistoryResult> {
  const response = await api.get<StatusHistoryResult>(
    `/carriers/${dotNumber}/status-history`,
    { params }
  );
  return response.data;
}

export const statusHistoryApi = {
  getCarrierStatusHistory,
};

export default statusHistoryApi;
